import React, { Fragment, useContext } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import {
  Container,
  Form,
  Button,
  Table,
  TableRow,
  TableCell,
  Popup,
  Icon,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import TextInput from "../../../../app/common/form/TextInput";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import arrayMutators from "final-form-arrays";
import { FieldArray } from "react-final-form-arrays";
import { ARRAY_ERROR } from "final-form";
import { toast } from "react-toastify";

const validateRecord = (values) => {
  var error = false;
  for (const x in values.prices) {
    if (values.prices[x] === undefined) {
      toast.error("Hay filas vacias");
      error = true;
    } else {
      try {
        if (values.prices[x].startNumber === undefined) {
          toast.error("No. de facturas DESDE no puede tener campos vacios");
          error = true;
        } else {
          if (values.prices[x].endNumber === undefined) {
            toast.error("No. de facturas HASTA no puede tener campos vacios");
            error = true;
          } else {
            if (values.prices[x].unitPrice === undefined) {
              toast.error("El Valor$ no puede tener campos vacios");
              error = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
        return true;
      }
    }
  }
  return error;
};

interface IProps {
  id: string;
}
const PackageBroker: React.FC<IProps> = ({ id }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    loadPackageBroker,
    getDataPackagesBrokers,
    postPackagesBrokers,
  } = rootStore.brokerStore;

  let bandera = false;

  const handleFinalFormSubmit = (values: any) => {
    if (bandera) {
      if (!validateRecord(values)) {
        postPackagesBrokers(values.prices, id);
        bandera = false;
      }
    }
  };

  const initialFormState = { prices: getDataPackagesBrokers(id) };

  if (!loadPackageBroker) return <LoadingComponent content="Cargando" />;

  return (
    <div>
      <FinalForm
        onSubmit={handleFinalFormSubmit}
        mutators={{
          ...arrayMutators,
        }}
        initialValues={initialFormState}
        render={({
          handleSubmit,
          form: {
            mutators: { push, pop },
          },
          values,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <Table basic="very">
                <Table.Header>
                  <TableRow>
                    <Table.HeaderCell className="thPackages">
                      No facturas <strong>desde</strong>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="thPackages">
                      No facturas <strong>hasta</strong>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="thPackages">
                      Valor $
                    </Table.HeaderCell>
                  </TableRow>
                </Table.Header>
                <Table.Body>
                  <FieldArray name="prices">
                    {({ fields }) =>
                      fields.map((name, index) => (
                        <TableRow key={name}>
                          <TableCell className="tdPackage">
                            <Field
                              name={`${name}.startNumber`}
                              component={TextInput}
                            />
                          </TableCell>
                          <TableCell className="tdPackage">
                            <Field
                              name={`${name}.endNumber`}
                              component={TextInput}
                            />
                          </TableCell>
                          <TableCell className="tdPackage">
                            <Field
                              name={`${name}.unitPrice`}
                              component={TextInput}
                            />
                          </TableCell>
                          <TableCell className="tdPackage">
                            <Fragment>
                              {values.prices.length - 1 !== index ? (
                                <Popup
                                  content="Click para eliminar fila"
                                  trigger={
                                    <Button
                                      icon
                                      onClick={() => fields.remove(index)}
                                    >
                                      <Icon name="delete" color="red" />
                                    </Button>
                                  }
                                />
                              ) : (
                                <Fragment>
                                  {values.prices.length > 1 && (
                                    <Popup
                                      content="Click para eliminar fila"
                                      trigger={
                                        <Button
                                          icon
                                          onClick={() => fields.remove(index)}
                                        >
                                          <Icon name="delete" color="red" />
                                        </Button>
                                      }
                                    />
                                  )}

                                  <Popup
                                    content="Click para agregar fila"
                                    trigger={
                                      <Button
                                        icon
                                        onClick={() =>
                                          push("prices", undefined)
                                        }
                                      >
                                        <Icon name="plus" color="green" />
                                      </Button>
                                    }
                                  />
                                </Fragment>
                              )}
                            </Fragment>
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </FieldArray>
                </Table.Body>
              </Table>
              <Button
                className="ui primary button"
                onClick={() => (bandera = true)}
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(PackageBroker);
